<!-- 开票弹窗 -->
<template>
  <div>
    <el-dialog :title="isEdit ? '修改开票' : '开票'" :visible.sync="visible" width="500px" :close-on-click-modal="false" @close="handleClose">
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" label-position="right">
        <el-form-item label="用户名称" prop="userName">
          <el-input v-model="formData.userName" placeholder="请输入用户名称" :disabled="true" clearable></el-input>
        </el-form-item>
        <el-form-item label="签约公司" prop="signCompanyName">
          <el-select v-model="formData.signCompanyName" placeholder="请选择签约公司" clearable style="width: 100%">
            <el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票额度" prop="money">
          <el-input-number v-model="formData.money" :min="0" :precision="2" placeholder="请输入发票额度" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="发票日期" prop="date">
          <el-date-picker
            v-model="formData.date"
            type="date"
            placeholder="请选择发票日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addInvoiceInfo, updateInvoiceInfo, getSignCompanyNameByInvoiceId } from '@/api/invoiceManagement'

export default {
  name: 'InvoiceApplyDialog',
  props: {
    // 控制弹窗显示
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 行数据（用于回显）
    rowData: {
      type: Object,
      default: () => ({})
    },
    // 是否编辑模式
    isEdit: {
      type: Boolean,
      default: false
    },
    // 发票ID（用于获取用户的签约公司）
    invoiceId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      visible: this.dialogVisible,
      submitLoading: false,
      formData: {
        detailId: '',
        invoiceId: '',
        userName: '',
        signCompanyName: '',
        money: undefined,
        date: ''
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      // 签约公司枚举
      companyOptions: [],
      rules: {
        userName: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        signCompanyName: [{ required: true, message: '请选择签约公司', trigger: 'change' }],
        money: [{ required: true, message: '请输入发票额度', trigger: 'blur' }],
        date: [{ required: true, message: '请选择发票日期', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getCompanyOptions()
  },
  watch: {
    dialogVisible(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('update:dialogVisible', val)
    },
    invoiceId: {
      handler() {
        this.getCompanyOptions()
      },
      immediate: false
    },
    rowData: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.formData.detailId = val.id || ''
          this.formData.invoiceId = val.invoiceId || ''
          this.formData.userName = val.userName || ''
          this.formData.signCompanyName =  ''
          this.formData.money = val.invoiceMoney
          this.formData.date = val.supplyDate || ''
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          let res
          if (this.isEdit) {
            res = await updateInvoiceInfo({
              detailId: this.formData.detailId,
              signCompanyName: this.formData.signCompanyName,
              money: this.formData.money,
              date: this.formData.date
            })
          } else {
            res = await addInvoiceInfo(this.formData)
          }
          if (res.statusCode === 200) {
            this.$message.success(this.isEdit ? '修改成功' : '开票成功')
            this.$emit('success')
            this.handleClose()
          } else {
            this.$message.error(res.message || (this.isEdit ? '修改失败' : '开票失败'))
          }
        } catch (error) {
          console.error(this.isEdit ? '修改失败' : '开票失败', error)
          this.$message.error(this.isEdit ? '修改失败' : '开票失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    // 取消
    handleCancel() {
      this.handleClose()
    },
    // 关闭弹窗
    handleClose() {
      this.visible = false
      this.resetForm()
    },
    // 获取签约公司选项
    async getCompanyOptions() {
      const id = this.invoiceId || (this.rowData && this.rowData.invoiceId)
      if (!id) return
      try {
        const res = await getSignCompanyNameByInvoiceId(id)
        if (res.statusCode === 200 && res.data) {
          this.companyOptions = res.data.map(item => ({
            label: item,
            value: item
          }))
        }
      } catch (error) {
        console.error('获取签约公司选项失败', error)
      }
    },
    // 重置表单
    resetForm() {
      this.formData = {
        detailId: '',
        invoiceId: '',
        userName: '',
        signCompanyName: '',
        money: undefined,
        date: ''
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  padding: 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/invoiceManagement/limitMonitoring/components/InvoiceApplyDialog.vue